module.exports = __webpack_public_path__ + "static/img/FoundWinners.0dbccbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FoundWinners.jpg
// module id = TJ1D
// module chunks = 4